import Vue from "vue";
import Vuex from "vuex";
import settings from './modules/settings'
import app from './modules/app'

Vue.use(Vuex);
//配置持久化操作vuex-persist
import VuexPersistence from "vuex-persist";

//创建对象配置持久化
const vuexLocal = new VuexPersistence({
  //定义本地存储的方式，sessionStorage或localStorage
  storage: window.localStorage,
});

export default new Vuex.Store({
  state: {
    user: "", //登陆对象
    tenant:null,//租户对象
    openTab: [], //所有打开的路由
    activeIndex: "首页", //激活状态
    roleArr: [], //TODO： 当前用户的路由权限
    dividerText: "首页", //侧边栏的文本提示
    columnIndex: 0, //最左侧的索引
    capital_info: {}, //客资信息
    tabstotal: [0, 0, 0, 0, 0, 0], //tabs条数
    statistics: {}, //table统计数据
    nodeMap: new Map(),
    isEdit: null,
    selectedNode: {},
    selectFormItem: null,
    design: {},
    transType: null, //编辑流程的事务类型(安全、隐患)

    MessageCount: 0, //消息通知的信息条数

    AgentInfo: {}, //待办数据

    permissions: [],//TODO: 权限数据
    roles: [],//TODO: 角色数据

    btnLoading: false,//按钮节流器

    fullscreen: false,//是否全屏

    Weather: null,//天气信息
    sidebarRouters: [], //侧边栏路由数据
  },
  mutations: {
    //更新登陆对象
    uploginUser(state, obj) {
      this.state.user = obj;
    },
    //更新租户对象
    uploginTenant(state, obj) {
      this.state.tenant = obj;
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    },
    // 添加tabs
    add_tabs(state, data) {
      if (!data) return;
      // 确保 label/route 存在，避免视图渲染报错
      const label = data.label || data.name || data.route || '未命名';
      const route = data.route || '/';
      const name = data.name || label;
      this.state.openTab.push({ label, route, name });
    },
    // 删除tabs
    delete_tabs(state, route) {
      let index = 0;
      for (let option of state.openTab) {
        if (option.route === route) {
          break;
        }
        index++;
      }
      this.state.openTab.splice(index, 1);
    },
    // 设置当前激活的tab
    set_active_index(state, index) {
      this.state.activeIndex = index;
    },
    // 设置最左侧标题的当前激活的tab
    set_column_index(state, val) {
      this.state.columnIndex = val.id;
      this.state.dividerText = val.text;
      // if(index == 0){
      //     this.state.dividerText = '主页';
      // }else{
      //     this.state.dividerText = '内容';
      // }
    },
    //删除全部路由标签
    delete_tabsAll(state, that) {
      this.state.openTab = [
        {
          label: "首页",
          name: "home",
          route: "/home",
        },
      ];
      this.state.activeIndex = this.state.openTab[0].route;
      that.$router.push({ path: this.state.openTab[0].route });
    },
    //更新客资信息
    upcapital_info(state, obj) {
      this.state.capital_info = obj;
    },
    //TODO：更新Agent侧边栏待办数据
    upAgent_info(state, obj) {
      this.state.AgentInfo = obj;
    },
    //更新tabs条数
    uptabstotal(state, arr) {
      this.state.tabstotal = arr;
    },
    //更新按钮节流
    upBtnLoading(state, flat) {
      this.state.btnLoading = flat;
    },
    //更新统计数据
    upStatistics(state, obj) {
      this.state.statistics = obj;
    },
    selectedNode(state, val) {
      state.selectedNode = val;
    },
    loadForm(state, val) {
      state.design = val;
    },
    setIsEdit(state, val) {
      state.isEdit = val;
    },
    upMsgCount(state, val) {
      state.MessageCount = val;
    },
    // 设置侧边栏路由
    SET_SIDEBAR_ROUTERS(state, routes) {
      state.sidebarRouters = routes;
    },
  },
  actions: {},
  modules: {
    settings,
    app,
  },
  getters: {},

  //配置插件支持
  plugins: [vuexLocal.plugin],
});
